import type { FaireProductEntity } from "../../entity_types/product";

export const p_c759kw56g7: FaireProductEntity = {
  token: "p_c759kw56g7",
  type: "product",
  name: "Birdie Love Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/dcd29a1a609d716f89ea491ed673d9623d7bb6d9886f0dea5240c2af82efa9ca.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6e7b57c01260c45224fc8c29f9831b6a03ef55d632944c7297f1b440c977dc1e.jpeg",
    "https://cdn.faire.com/fastly/036d9fddc5dc161905e70bf195824b36ab594141031daff51197ee7ebe5441c3.jpeg",
    "https://cdn.faire.com/fastly/996d12cfea5275b17689f26079b48ad162e8f4d7362ba44c8cf9c10dc7aafb94.jpeg",
  ],
  priceDollars: 7,
  description:
    '"Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.',
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:55.672Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
